/* eslint-disable @typescript-eslint/no-unused-vars */
// react fc
import { Section, SectionsIds } from '@services/common.services'
import { FC, useEffect, useState } from 'react'
import { Wizard } from 'react-use-wizard'
import StepContainer from './StepContainer'
import { transformFormData } from '@utils/helper/quiz.helper'
import StepHeader from './StepHeader'

interface Props {
  data: Section
  onSubmitSection: (data: any, sectionId: SectionsIds) => void
  isSubmitting?: boolean
}

const MultiStep: FC<Props> = ({ data, onSubmitSection, isSubmitting }) => {
  const [formData, setFormData] = useState({})
  const [isWizardFinished, setIsWizardFinished] = useState(false)

  useEffect(() => {
    setFormData({}) // Clear formData for new section
    setIsWizardFinished(false) // Reset wizard state
  }, [data])

  useEffect(() => {
    if (isWizardFinished) {
      // Trigger onSubmitSection with the latest formData
      const transformedData = transformFormData(formData, data.quiz_items)
      // eslint-disable-next-line no-console

      onSubmitSection(transformedData, data.section_id)

      // Reset the wizard completion flag (optional)
      setIsWizardFinished(false)
    }
  }, [isWizardFinished])

  const handleSubmit = (data: any) => {
    setFormData((prevData) => ({ ...prevData, ...data }))
  }

  const handleFinish = (finalStepData: any) => {
    // eslint-disable-next-line no-console
    setFormData((prevData) => ({ ...prevData, ...finalStepData }))
    setIsWizardFinished(true)
  }

  return (
    <>
      <Wizard
        key={`${data.section_id}-${data.quiz_items.length}`}
        header={<StepHeader steps={data.quiz_items.length} title={data.name} />}
      >
        {data.quiz_items.map((item) => {
          return (
            <StepContainer
              isSubmitting={isSubmitting}
              key={`${data.section_id}-${item.id}`}
              data={item}
              formData={formData}
              onSubmit={handleSubmit}
              onSubmitFinal={handleFinish}
            />
          )
        })}
      </Wizard>
    </>
  )
}

export default MultiStep
